@if (model()) {
<div class="endpoint">
    <app-select [formGroup]="formGroup()!" [meta]="metaEndpoint" [model]="$safeNavigationMigration(model()?.endpoint)" (change)="onEndpoint($event)"></app-select>
    @if (parameters?.length) {
    <ng-container [formArray]="arrayImport">
        @for (parameter of parameters; track parameter.value.name; let i = $index) {
        <app-option [formGroup]="$any($safeNavigationMigration(arrayImport?.at(i)))" [model]="parameter.value" [meta]="parameter.meta"></app-option>
        }
    </ng-container>
    }
    @if (endpoint()?.data?.editable) {
    <app-textarea [formGroup]="formGroup()!" [model]="body" [meta]="metaContent"></app-textarea>
    }
    <app-json [formGroup]="formResponse" [meta]="metaResponse" [model]="$safeNavigationMigration(model()?.jsonResponse)" (update)="onJson($event)"></app-json>
</div>
}
